import { useEffect, useState } from 'react';

// Below Tailwind's `md` (768) is mobile, so tablets get desktop. The second clause keeps a
// phone on mobile when rotated; touch laptops report a fine pointer and stay desktop.
const MOBILE_QUERY =
  '(max-width: 767px), (pointer: coarse) and (max-height: 500px)';

const matchesMobile = () => window.matchMedia(MOBILE_QUERY).matches;

// `isDeviceReady` flips true after mount, for consumers that gate layout-sensitive rendering on it.
export const useMobileUI = (): {
  isMobileUI: boolean;
  isDeviceReady: boolean;
} => {
  const [isMobileUI, setIsMobileUI] = useState(matchesMobile);
  const [isDeviceReady, setIsDeviceReady] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(MOBILE_QUERY);
    const evaluate = () => setIsMobileUI(media.matches);

    evaluate();
    setIsDeviceReady(true);
    media.addEventListener('change', evaluate);
    return () => media.removeEventListener('change', evaluate);
  }, []);

  return { isMobileUI, isDeviceReady };
};
